import WinnerModal from './winner-modal';
export default WinnerModal;
